/*global translate*/
import React, { Component } from 'react'
const {changeColorSVG} = global.rootRequire('classes/ulti')

const RxPopupUpload = global.rootRequire('components/shares/rxPopupUpload').default

global.isclient && require('./rxUploadFile.css')

class RxUploadFile extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      type: 0,
      flagPopup: false,
      flagBoxPopup: false,
      theInputFileKey:'',
      fileListArr: [],
      fileList: {},
      acceptFile: ''
    }
    this.objMessCancel = {}
    this.objFiles = {}
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.uploadFileImages = this.uploadFileImages.bind(this)
    this.uploadLoadingFile= this.uploadLoadingFile.bind(this)
    this.cancleUpload = this.cancleUpload.bind(this)
    this.uploadInputImage = null
    this.uploadInputDoc = null
    this.uploadInputAll = null
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    // if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
    //   this.setState({flagPopup: false})
    // }
  }

  onClickDataUpload(e, type) {
    if (type === 'image') {
      this.uploadInputImage.click()
    } else if (type === 'doc') {
      this.uploadInputDoc.click()
    } else {
      this.uploadInputAll.click()
    }
  }

  onChangeDataFile(e, type) {
    e.stopPropagation()
    e.preventDefault()
    if (this.props.token) {
      let fileList = e.target.files
      if (fileList && fileList.length > 0) {

        let acceptFile = 'image/*,video/mp4'
        if (type === 'doc') {
          acceptFile = '.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.svg,.pdf,.numbers,.key,.pages,.zip,.rar,.m4a,.mp3,.css,.eps,.raw,.cr2,.nef,.orf,.sr2,.TIF,.TIFF,.PSD,.XCF,.AI,.CDR,.CSS,.DXF,.EPS,.FLV,.HTML,.ICO,.RTF,.MTS,.ODS,.ODT,.OGG,.PHP,.PS,.PSD,.PUB,.SVG,.TSV,.TTF,.WAV,.WMV,.XPS,.JSON,.csv,.xml,.exe,.dmg,.mmap,.emmx,.mov,.AVI,.M4V'
        }

        this.setState({
          flagBoxPopup: true,
          acceptFile: acceptFile
        }, () => {
          let eleZchatLeft = document.querySelectorAll(".zchat_left")
          if (eleZchatLeft) {
            for (let i = 0; i < eleZchatLeft.length; i++) {
              eleZchatLeft[i].style.zIndex = 7;
            }  
          }
        })

        let fileListArr = []
        for (let i = 0; i < fileList.length; i++) {
          let file = fileList[i]
          let fileTmp = {}
          let _URL = window.URL || window.webkitURL
          let objectUrl = _URL.createObjectURL(fileList[i])
          fileTmp.name = fileList[i].name
          fileTmp.size = this.convertFileSize(fileList[i].size)
          fileTmp.url = objectUrl
          fileTmp.type = this.getFileType(fileList[i].name)
          if(['image','video','filedoc'].indexOf(fileTmp.type) !== -1){          
            fileListArr.push(fileTmp)
          }
        }

        this.setState({
          theInputFileKey: new Date().getTime().toString(),
          fileListArr: fileListArr,
          fileList: fileList
        })
      }
    }
  }

  onChangeDataFilePopup(e) {
    let mess = ''
    let typemess = ''
    if (e && e.mess) {
      mess = e.mess
    }

    let fileObj = {'image': [], 'video': [], 'filedoc': []}

    if (this.props.token) {
      let fileList = this.state.fileList
      for (let i = 0; i < fileList.length; i++) {
        let fileTypeTmp = this.getFileType(fileList[i]['name'])
        fileObj[fileTypeTmp].push(fileList[i])
      }

      let fileKeys = Object.keys(fileObj)
      for (let i = 0; i <= fileKeys.length; i++) {
        if (fileObj[fileKeys[i]].length > 0) {
          typemess = fileKeys[i]
          break
        }
      }
    
      if (fileObj['image'].length > 0) {
        let messtmp = (typemess === 'image') ? mess : ''
        this.uploadFileImages(fileObj['image'], messtmp)
      } 

      if (fileObj['video'].length > 0) {
        let messtmp = (typemess === 'video') ? mess : ''
        this.uploadFileVideos(fileObj['video'], messtmp)
      } 

      if (fileObj['filedoc'].length > 0) {
        let messtmp = (typemess === 'filedoc') ? mess : ''
        this.uploadFileDoc(fileObj['filedoc'], messtmp)
      }
    }

    this.props.handleDragOut()
    this.setState({
      flagBoxPopup: false,
      theInputFileKey: new Date().getTime().toString()
    })
  }

  editFileSelected(index,files){
    let fileListTmp = [];
    let fileList = this.state.fileList
    let fileListArr = this.state.fileListArr
    let fileTmp = {}
    let _URL = window.URL || window.webkitURL
    let objectUrl = _URL.createObjectURL(files[0])

    fileTmp.name = files[0].name
    fileTmp.size = this.convertFileSize(files[0].size)
    fileTmp.url = objectUrl
    fileTmp.type = this.getFileType(files[0].name)    
    fileListArr[index] = fileTmp
    if (['image','video','filedoc'].indexOf(fileTmp.type) !== -1){
      for (let i = 0 ; i < fileList.length ; i++) {
        if(i !== index){
          fileListTmp.push(fileList[i])  
        }else{
          fileListTmp.push(files[0])
        }
      };
      this.setState({
        fileListArr:fileListArr,
        fileList:fileListTmp
      }) 
    } else {
      let imageExtArr = [' jpg', ' gif', ' bmp', ' png', ' jpeg', ' webp', ' jfif', ' pjpeg', ' pjp']
      let videoExtArr = [' m4v', ' mpg', ' mp4', ' MOV', 'M4V']
      let docExtArr = [' xlsx', ' xls', ' doc', ' docx', ' ppt', ' pptx', ' txt',' svg', ' pdf', ' numbers',' key',' pages',' zip',' rar',' m4a',' mp3', ' css', ' eps', ' raw', ' cr2', ' nef', ' orf', ' sr2',
                        ' TIF', ' TIFF', ' PSD', ' XCF', ' AI', ' CDR', ' DXF', ' EPS', ' FLV', ' HTML', ' ICO', ' RTF', ' MTS', ' ODS', ' ODT', ' OGG', ' PHP', ' PS', ' PSD',
                        ' PUB', ' TSC', ' TSV', ' TTF', ' WMV', ' XPS', ' JSON', ' csv', ' xml', ' exe', ' dmg', ' mmap', ' emmx', ' WAV', ' avi']
      alert(translate('The file format is not suitable. Please select the file as'+ docExtArr + ',' + imageExtArr + ',' + videoExtArr))
    } 
  }

  deleteFileSelected(index){
    let fileListTmp = [];
    let fileList = this.state.fileList
    let fileListArr = this.state.fileListArr
    let flagBoxPopup = true
    
    fileListArr.splice(index,1)
    if(fileListArr.length === 0){
      flagBoxPopup = false
    }

    for (let i = 0 ; i < fileList.length ; i++) {
      if(i !== index){
        fileListTmp.push(fileList[i])  
      }
    };

    this.setState({
      fileListArr: fileListArr,
      fileList: fileListTmp,
      flagBoxPopup: flagBoxPopup
    })  
  }

  uploadFileDoc(fileList, mess) {
    let checkExtFile = true

    for (let i = 0; i < fileList.length; i++) {
      let ext = this.getExtension(fileList[i]['name']).toLowerCase();
      if (['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'svg', 'pdf', 'numbers', 'key', 'pages', 'zip', 'rar', 'm4a', 'mp3', 'css','eps', 'raw', 'cr2', 'nef', 'orf', 'sr2',
          'tif', 'tiff', 'psd', 'xcf', 'ai', 'cdr', 'dxf', 'eps', 'flv', 'html', 'ico', 'rtf', 'mts', 'ods', 'odt', 'ogg', 'php', 'ps', 'psd',
          'pub', 'tsc', 'tsv', 'ttf', 'wmv', 'xps', 'json', 'csv', 'xml', 'exe', 'dmg', 'mmap', 'emmx', 'wav', 'avi'].indexOf(ext) === -1) {
        checkExtFile = false
        break;
      }
    }
    if (checkExtFile) {                                  
      let arrImg = [], arrL=[]
      for (let i = 0; i < fileList.length; i++) {
        let ext = this.getExtension(fileList[i]['name']);
        if (typeof (fileList[i]) !== 'undefined') {
          let file = fileList[i]
          let fileSize = fileList[i].size
          // let extFilename = this.getExtension(fileList[i]['name'])

          if (fileSize < (1024*1024*100)) {
            let message_id = (Math.floor(Date.now())+i * 1000).toString()
            arrL.push(message_id)
            this.uploadLoadingFile(file,message_id,'file')
            let fileTypeTmp = file.type
            if(ext === 'numbers'){
              fileTypeTmp = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'// file type of xlsx file
            }

            if(ext === 'pages'){
              fileTypeTmp = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'// file type of docx file
            }

            if (['m4a','mp3','ogg','wav'].indexOf(ext) !== -1 ) {
              fileTypeTmp = 'audio/m4a'
            }

            if (['rar'].indexOf(ext) !== -1) {
              fileTypeTmp = 'application/x-rar-compressed'  
            }

            if (['doc','docx'].indexOf(ext) !== -1) {
              fileTypeTmp = 'application/msword'
            }

            if (['ppt','pptx','key'].indexOf(ext) !== -1) {
              fileTypeTmp = 'application/vnd.ms-powerpoint'
            }

            if(['dxf', 'orf', 'nef', 'psd', 'xcf', 'tiff', 'ico'].indexOf(ext) !== -1) {
              fileTypeTmp = 'image/png'
            } 

            if(['mts', 'avi', 'flv', 'wmv', 'mov'].indexOf(ext) !== -1) {
              fileTypeTmp = 'video/mp4'
            }

            if(['css', 'html', 'php', 'rtf', 'tsv'].indexOf(ext) !== -1) {
              fileTypeTmp = 'text/plain'
            }

            if (fileTypeTmp === '') {
              fileTypeTmp = 'application/'
            }

            let dataParams = {
              content_type: fileTypeTmp,
              name: 'netalo_file_' + Math.floor(Date.now()),
              public: true,
              size: fileSize
            }

            let header = { 'TC-Token': this.props.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
            let requestOptions = {
              method: 'POST',
              headers: header,
              body: JSON.stringify(dataParams),
              redirect: 'follow'
            };
            fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
              if (json && json.blod_object && json.blod_object.form_data) {
                let dataUpload = new FormData()
                let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
                for (let key of arrKeys) {
                  if (json.blod_object.form_data[key]) {
                    dataUpload.append(key, json.blod_object.form_data[key])
                  }
                }
                dataUpload.append('file', file, file.name)
                dataUpload.append('success_action_status', 201)

                fetch(json.blod_object.params, { method: 'POST', body: dataUpload }).then(resBlob => resBlob.text()).then(result => {
                  if (result.indexOf('Key') !== -1) {
                    let patt = '<Key.*?>(.*?)<\\/Key>';
                    let strresult = result.match(patt);
                    if (strresult && strresult.constructor === Array && strresult.length > 1) {
                      let key = strresult[1]
                      if (key) {
                        let optComplete = {
                          method: 'PUT',
                          headers: header,
                          body: JSON.stringify({
                            content_type: json.content_type,
                            id: json.id,
                            name: json.name,
                            size: json.size,
                            uid: json.uid
                          })
                        };

                        fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                          .then(response => {
                            let checkRemove = false
                            for (let key of Object.keys(this.objFiles)) {
                              if (this.objMessCancel[key]) {
                                checkRemove = true
                                delete this.objMessCancel[key]
                              }
                              if (key === message_id) {
                                delete this.objFiles[key]
                              }
                            }
                            if (!checkRemove) {
                              if (response.status === 200) {
                                try {
                                  if (arrL.length > 0) {
                                    let ele = document.getElementById(arrL[0]);
                                    // ele && ele.closest("div.zmessage_row").remove();
                                    if(ele){
                                      ele.closest("div.zmessage_row").style.display="none";
                                    }
                                  }
                                  let filename  = fileList[i]['name']
                                  filename = filename.replace('.' + ext ,'')
                                  let objSize = {
                                    file_extension: ext,
                                    file_name: filename,
                                    size: fileSize,
                                    url: key
                                  }
                                  
                                  if (ext.indexOf('zip') !== -1) {
                                    objSize['file_extension'] = 'zip'
                                    objSize['file_name'] = fileList[i]['name'].replace('.zip', '')
                                  }

                                  arrImg.push(objSize)

                                  if (arrImg.length === fileList.length) {
                                    this.setState({flagPopup: false}, () => {
                                      this.uploadInputImage = null
                                      this.uploadInputDoc = null
                                      this.uploadInputAll = null
                                      this.props.callback(arrImg, 'file', mess)
                                    })
                                    
                                  }
                                } catch (e) { }
                              }
                            } else {
                              console.log('Is cancle uploader')
                            }
                          })
                          .catch(errorPut => console.log('error', errorPut));
                      }
                    }
                  }
                })
              }
            }).catch(error => console.log('error', error))
          } else {
            alert('File size is too large')
          }          
        }
      }
    } else {
      alert(translate('The file format is not suitable. Please select the file as .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .svg, .pdf, .numbers, .key, .pages, .zip, .rar'))
    }
  }

  uploadFileImages(fileList, mess) {
    let checkExtFile = true
    for (let i = 0; i < fileList.length; i++) {
      if (['png', 'jpg', 'jpeg', 'webp', 'jfif', 'pjpeg', 'pjp'].indexOf(this.isImage(fileList[i]['name'])) === -1) {
        checkExtFile = false
        break;
      }
    }
    if (checkExtFile) {
      let arrImg = [], arrL=[]
      for (let i = 0; i < fileList.length; i++) {
        if (typeof (fileList[i]) !== 'undefined') {
          let file = fileList[i]
          let fileSize = fileList[i].size
          if (this.isImage(file.name) && ['png', 'jpg', 'jpeg', 'webp', 'jfif', 'pjpeg', 'pjp'].indexOf(this.isImage(file.name)) !== -1) {
            let extFilename = 'png'

            let _URL = window.URL || window.webkitURL
            let img = new Image();
            let objectUrl = _URL.createObjectURL(file)

            let message_id = (Math.floor(Date.now())+i * 1000).toString()
            arrL.push(message_id)
            this.uploadLoadingFile(file,message_id,'image')

            let dataParams = {
              content_type: 'image/' + extFilename,
              name: 'netalo_' + Math.floor(Date.now()),
              public: true,
              size: fileSize
            }
            let header = { 'TC-Token': this.props.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
            let requestOptions = {
              method: 'POST',
              headers: header,
              body: JSON.stringify(dataParams),
              redirect: 'follow'
            };

            fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
              if (json && json.blod_object && json.blod_object.form_data) {
                let dataUpload = new FormData()
                let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
                for (let key of arrKeys) {
                  if (json.blod_object.form_data[key]) {
                    dataUpload.append(key, json.blod_object.form_data[key])
                  }
                }
                dataUpload.append('file', file, file.name)
                dataUpload.append('success_action_status', 201)

                fetch(json.blod_object.params, { method: 'POST', body: dataUpload })
                .then(resBlob => resBlob.text())
                .catch((error) => { console.log(error) })
                .then(result => {
                  if (result && result.indexOf('Key') !== -1) {
                    let patt = '<Key.*?>(.*?)<\\/Key>';
                    let strresult = result.match(patt);
                    if (strresult && strresult.constructor === Array && strresult.length > 1) {
                      let key = strresult[1]
                      if (key) {
                        let optComplete = {
                          method: 'PUT',
                          headers: header,
                          body: JSON.stringify({
                            content_type: json.content_type,
                            id: json.id,
                            name: json.name,
                            size: json.size,
                            uid: json.uid
                          })
                        };

                        fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                          .then(response => {
                            if (response.status === 200) {
                              let checkRemove = false
                              for (let key of Object.keys(this.objFiles)) {
                                if (this.objMessCancel[key]) {
                                  checkRemove = true
                                  delete this.objMessCancel[key]
                                }
                                if (key === message_id) {
                                  delete this.objFiles[key]
                                }
                              }
                              if (!checkRemove) {
                                console.log('Is uploader')
                                try {
                                  if (i === fileList.length - 1) {
                                    arrL.map(il => {
                                      let ele = document.getElementById(il);
                                      // ele && ele.closest("div.zmessage_row").remove();
                                      if(ele){
                                        ele.closest("div.zmessage_row").style.display="none";
                                      }
                                      return
                                    })
                                  }
                                  img.onload = () => {
                                    let objSize = { width: img.width || 960, height: img.height || 720, url: key }
                                    arrImg.push(objSize)
                                    if (arrImg.length === fileList.length) {
                                      this.props.callback(arrImg, 'image', mess)
                                      _URL.revokeObjectURL(objectUrl)
                                    }
                                  }
                                  img.src = objectUrl

                                  this.setState({flagPopup: false}, () => {
                                    this.uploadInputImage = null
                                    this.uploadInputDoc = null
                                    this.uploadInputAll = null
                                  })

                                } catch (e) { }
                              } else {
                                console.log('Is cancle uploader')
                              }
                            }
                          })
                          .catch(errorPut => console.log('error', errorPut));
                      }
                    }
                  }
                })
              }
            }).catch(error => console.log('error', error))
          } else {
            alert(translate('The image file format is not suitable'))
          }
        }
      }
    } else {
      alert(translate('The image file format is not suitable. Please select the image file as .jpg, .png, .jpeg .webp, .jfif, .pjpeg, .pjp'))
    }
  }

  cancleUpload(messid) {
    this.objMessCancel[messid] = 1
  }

  uploadLoadingFile(file,message_id,type){
    try {
      let fileType 
      let attachments
      let reader = new FileReader();
      let url = URL.createObjectURL(file)
      let that = this

      this.objFiles[message_id] = ''

      let params = {
            "message_id": message_id,
            "created_at": (Math.floor(Date.now()) * 1000).toString(),
            "group_id": that.props.group_id, "message": "",
            "sender_uin": that.props.userid,
            "updated_at": "0", "pinned_at": "0", "order_id": "0", "status": 0,
            // "type": fileType,
            // "attachments": attachments,
            "group_type": 2, "nonce": "", "version": 1, "is_encrypted": false,
            "callback": this.cancleUpload
          }

      that.props.handleDragOut() 
      if (type === 'image') {
        const img = new Image()
        img.onload = function() { 
          params.type = 2
          params.attachments = `{"loading":true,"images":[{
                            "url":"${url}"}]}`
          that.props.handleMessage(params, true)     
        }
        img.src = url
      }
      if (type === 'video') {
        const video = document.createElement("video");
        video.src = url;
        video.addEventListener("loadedmetadata", function () {
          params.type = 4
          params.attachments = `{"loading":true,"video":{
                          "url":"${url}","width":"${this.videoWidth}","height":"${this.videoHeight}"}}`
          params.name = file.name
          that.props.handleMessage(params, true) 
        });
      }
      if (type === 'file') {
        params.type = 12
        params.attachments = `{"loading":true,
                        "file":{
                          "url":"${url}",
                          "file_extension":"${this.getExtension(file['name'])}",
                          "size":"${file.size}",
                          "file_name":"${file.name}"                          
                        }}`
        params.name = (file.name) ? file.name.replace('.'+this.getExtension(file['name']),'') : ''
        that.props.handleMessage(params, true)  
      }
    } catch (error) {
    }
  }

  uploadThumnail(image, videokey, mess) {
    if (image.base64 && image.width > 0) {
      let dataParams = {
        content_type: image.type,
        name: image.filename,
        public: true,
        size: image.size
      }
      let header = { 'TC-Token': this.props.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
      let requestOptions = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(dataParams),
        redirect: 'follow'
      };

      fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
        if (json && json.blod_object && json.blod_object.form_data) {
          let dataUpload = new FormData()
          let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
          for (let key of arrKeys) {
            if (json.blod_object.form_data[key]) {
              dataUpload.append(key, json.blod_object.form_data[key])
            }
          }
          dataUpload.append('file', image.file, image.file.name)
          dataUpload.append('success_action_status', 201)

          fetch(json.blod_object.params, { method: 'POST', body: dataUpload }).then(resBlob => resBlob.text()).then(result => {
            if (result.indexOf('Key') !== -1) {
              let patt = '<Key.*?>(.*?)<\\/Key>';
              let strresult = result.match(patt);
              if (strresult && strresult.constructor === Array && strresult.length > 1) {
                let key = strresult[1]
                if (key) {
                  let optComplete = {
                    method: 'PUT',
                    headers: header,
                    body: JSON.stringify({
                      content_type: json.content_type,
                      id: json.id,
                      name: json.name,
                      size: json.size,
                      uid: json.uid
                    })
                  };

                  fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                    .then(response => {
                      if (response.status === 200) {
                        try {
                          let objSize = {
                            width: image.videoWidth || 960,
                            height: image.videoHeight || 720,
                            thumbnail_url: key,
                            duration: image.duration,
                            url: videokey
                          }
                          
                          let checkRemove = false
                          for (let key of Object.keys(this.objFiles)) {
                            if (this.objMessCancel[key]) {
                              checkRemove = true
                              delete this.objMessCancel[key]
                            }
                            if (this.objFiles[key] === image.filename) {
                              delete this.objFiles[key]
                            }
                          }
                          if (!checkRemove) {
                            console.log('Is uploader')
                            this.props.callback([objSize], 'video', mess)
                          } else {
                            console.log('Is cancle uploader')
                          }
                        } catch (e) { }
                      }
                    })
                    .catch(errorPut => console.log('error', errorPut));
                }
              }
            }
          })
        }
      }).catch(error => console.log('error', error))
    }
  }

  uploadVideo(file, image, mess) {
    let arrL=[]
    let message_id = (Math.floor(Date.now()) * 1000).toString()
    arrL.push(message_id)
    this.uploadLoadingFile(file,message_id,'video')

    let dataParams = {
      content_type: 'video/mp4',
      name: 'netalo_video_' + Math.floor(Date.now()),
      public: true,
      size: file.size
    }
    let header = { 'TC-Token': this.props.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
    let requestOptions = {
      method: 'POST',
      headers: header,
      body: JSON.stringify(dataParams),
      redirect: 'follow'
    };

    fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
      if (json && json.blod_object && json.blod_object.form_data) {
        let dataUpload = new FormData()
        let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
        for (let key of arrKeys) {
          if (json.blod_object.form_data[key]) {
            dataUpload.append(key, json.blod_object.form_data[key])
          }
        }
        dataUpload.append('file', file, file.name)
        dataUpload.append('success_action_status', 201)

        fetch(json.blod_object.params, { method: 'POST', body: dataUpload }).then(resBlob => resBlob.text()).then(result => {
          if (result.indexOf('Key') !== -1) {
            let patt = '<Key.*?>(.*?)<\\/Key>';
            let strresult = result.match(patt);
            if (strresult && strresult.constructor === Array && strresult.length > 1) {
              let key = strresult[1]
              if (key) {
                let optComplete = {
                  method: 'PUT',
                  headers: header,
                  body: JSON.stringify({
                    content_type: json.content_type,
                    id: json.id,
                    name: json.name,
                    size: json.size,
                    uid: json.uid
                  })
                };

                fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                  .then(response => {
                    if (response.status === 200) {
                      try {
                        if (arrL.length > 0) {
                          let ele = document.getElementById('video'+ arrL[0]);
                          // ele && ele.closest("div.zmessage_row").remove();
                          if(ele){
                            ele.closest("div.zmessage_row").style.display="none";
                          }
                        }

                        this.objFiles[message_id] = image.filename
                        this.uploadThumnail(image, key, mess)

                        this.setState({flagPopup: false}, () => {
                          this.uploadInputImage = null
                          this.uploadInputDoc = null
                          this.uploadInputAll = null
                        })
                      } catch (e) { }
                    }
                  })
                  .catch(errorPut => console.log('error', errorPut));
              }
            }
          }
        }).catch(error => {
          alert(translate('Video size is too large'))
        })
      }
    }).catch(error => console.log('error', error))
  }

  uploadFileVideos(fileList, mess) {
    let checkExtFile = true
    let videoExt = ['m4v', 'mpg', 'mp4', 'mov']
    for (let i = 0; i < fileList.length; i++) {
      if (videoExt.indexOf(this.isVideo(fileList[i]['name'])) === -1) {
        checkExtFile = false
        break;
      }
    }
    if (checkExtFile) {
      for (let i = 0; i < fileList.length; i++) {
        if (typeof (fileList[i]) !== 'undefined') {
          let file = fileList[i]
          let fileSize = fileList[i].size

          if (fileSize <= 262144000) {
            this.capture(file, (image) => {
              if (i !== (fileList.length - 1)) {
                mess = ''
              }
              this.uploadVideo(file, image, mess)
            })
          } else {
            alert(translate('Video size is too large'))
          }
        }
      }
    } else {
      alert(translate('The video file format is not suitable. Please select the video file as .mp4, .m4v, .mpg, .MOV'))
    }
  }

  getExtension(filename) {
    let parts = filename.split('.');
    return parts[parts.length - 1];
  }

  isImage(filename) {
    let ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'png':
      case 'webp':
      case 'jfif':
      case 'pjpeg':
      case 'pjp':
        return ext.toLowerCase();
      default:
        break;
    }
    return '';
  }

  isVideo(filename) {
    let ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'm4v':
      case 'mpg':
      case 'mp4':
      case 'mov':
        return ext.toLowerCase();
      default:
        break;
    }
    return '';
  }

  capture(file, callback) {
    try {
      var fileReader = new FileReader()
      fileReader.onload = function () {
        var blob = new Blob([fileReader.result], { type: file.type })
        var url = URL.createObjectURL(blob)
        var video = document.createElement('video')
        var timeupdate = function () {
          if (snapImage()) {
            video.removeEventListener('timeupdate', timeupdate)
            video.pause()
          }
        }
        video.addEventListener('loadeddata', function () {
          if (snapImage()) {
            video.removeEventListener('timeupdate', timeupdate)
          }
        })
        var dataURLtoFile = function (dataurl, filename) {
          var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, { type: mime });
        }
        var snapImage = function () {
          var canvas = document.createElement('canvas')
          canvas.width = video.videoWidth * 0.25
          canvas.height = video.videoHeight * 0.5
          canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
          var image = canvas.toDataURL('image/jpeg')
          var success = image.length > 5000
          if (success) {
            let filename = 'netalo_thumbnail_' + Math.floor(Date.now())
            let arrimg = image.split(',')[1]

            let objImg = {
              base64: image,
              width: canvas.width,
              height: canvas.height,
              videoWidth: video.videoWidth,
              videoHeight: video.videoHeight,
              duration: Math.ceil(video.duration),
              type: 'image/png',
              size: Math.floor((new Buffer(arrimg, 'base64').length)),
              filename: filename,
              file: dataURLtoFile(image, `${filename}.jpg`),
            }
            callback(objImg)
            URL.revokeObjectURL(url)
          }
          return success
        }
        video.addEventListener('timeupdate', timeupdate)
        video.preload = 'metadata'
        video.src = url
        video.muted = true
        video.playsInline = true
        video.play()
      }

      fileReader.readAsArrayBuffer(file)
    } catch (e) {
      console.log(e)
    }
  }

  toggleDataUpload() {
    let flagPopup = this.state.flagPopup
    this.setState({flagPopup: !flagPopup})
  }

  getFileType(filename){
    let ext = this.getExtension(filename);
    let imageExtArr = ['jpg', 'gif', 'bmp', 'png', 'jpeg', 'webp', 'jfif', 'pjpeg', 'pjp']
    let videoExtArr = ['m4v', 'mpg', 'mp4', 'mov', 'm4v']
    let docExtArr = ['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'svg', 'pdf', 'numbers','key','pages','zip','rar','m4a','mp3', 'css', 'eps', 'raw', 'cr2', 'nef', 'orf', 'sr2',
    'tif', 'tiff', 'psd', 'xcf', 'ai', 'cdr', 'dxf', 'eps', 'flv', 'html', 'ico', 'rtf', 'mts', 'ods', 'odt', 'ogg', 'php', 'ps', 'psd',
    'pub', 'tsc', 'tsv', 'ttf', 'wmv', 'xps', 'json', 'csv', 'xml', 'exe', 'dmg', 'mmap', 'emmx', 'wav', 'avi']
    if(imageExtArr.indexOf(ext.toLowerCase()) !== -1){
      return 'image'
    }else if(videoExtArr.indexOf(ext.toLowerCase()) !== -1){
      return 'video'
    } else if(docExtArr.indexOf(ext.toLowerCase()) !== -1){
      return 'filedoc'
    }
    return ext.toLowerCase()
  }

  getExtension(filename) {
    let parts = filename.split('.');
    return parts[parts.length - 1];
  }

  convertFileSize(size){
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let index = 0, newsize = parseInt(size, 10) || 0;

    while(newsize >= 1024 && ++index){
        newsize = newsize/1024;
    }
    //include a decimal point and a tenths-place digit if presenting 
    //less than ten of KB or greater units
    return(newsize.toFixed(newsize < 10 && index > 0 ? 1 : 0) + ' ' + units[index]);
  }

  dropCanceBtnClick() {
    this.setState({
      flagBoxPopup: false,

    }, () => {
      let eleZchatLeft = document.querySelectorAll(".zchat_left")
      if (eleZchatLeft) {
        for (let i = 0; i < eleZchatLeft.length; i++) {
          eleZchatLeft[i].style.zIndex = 8;
        }  
      }
    })
  }

  createPollClick(){
    this.setState({flagPopup: false}, () => {
      this.props.createPollClick()
    })
  }

  render() {
    return (
      <div className='box-upload-wrap' ref={this.wrapperRef}>
        <img src={changeColorSVG('./images/default/static/plus.svg')} alt='icon-like' className='icon-upload-file icons-sticker filter_img_class'  onClick={(e) => this.toggleDataUpload()} />
        <div className='box-upload' style={{display: this.state.flagPopup ? "block" : "none"}}>
          {
            this.props.group &&
            this.props.group.owner_uin &&
            this.props.group.type !== 3 &&
            this.props.group.owner_uin.toString() === this.props.userid.toString() &&

            <div className='type-upload-poll' onClick={(e) => this.createPollClick()}>
              <img src={changeColorSVG('./images/default/static/icon-poll.svg')} alt='' className='icon-pool'  />
              {translate('Create Poll')}
            </div>
          }
          {/* <div className='type-upload' onClick={(e) => this.onClickDataUpload(e, 'image')}>
            <span className='icon-picture type-upload-icon'></span>
            {translate('Photos and Videos')}
          </div>
          <div className='type-upload' onClick={(e) => this.onClickDataUpload(e, 'doc')}>
            <span className='icon-doc type-upload-icon'></span>
            {translate('Documents and Files')}
          </div> */}
          <div className='type-upload' onClick={(e) => this.onClickDataUpload(e)}>
            <span className='icon-doc type-upload-icon'></span>
            {translate('Add attachment(s)')}
          </div>
        </div>

        {/* <input ref={(ref) => { this.uploadInputImage = ref}} type='file' multiple={true} key={this.state.theInputFileKey + '_data_image'} style={{ display: 'none' }} onChange={(e) => this.onChangeDataFile(e, 'image')} accept="image/*,video/mp4,video/quicktime" /> */}

        {/* <input ref={(ref) => { this.uploadInputDoc = ref}} type='file' multiple={false} key={this.state.theInputFileKey + '_data_doc'} style={{ display: 'none' }} onChange={(e) => this.onChangeDataFile(e, 'doc')} accept=".xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.svg,.pdf,.numbers,.key,.pages,.zip,.rar,.m4a,.mp3,.css,.eps,.raw,.cr2,.nef,.orf,.sr2,.TIF,.TIFF,.PSD,.XCF,.AI,.CDR,.CSS,.DXF,.EPS,.FLV,.HTML,.ICO,.RTF,.MTS,.ODS,.ODT,.OGG,.PHP,.PS,.PSD,.PUB,.SVG,.TSV,.TTF,.WAV,.WMV,.XPS,.JSON,.csv,.xml,.exe,.dmg,.mmap,.emmx,.mov,.AVI,.M4V" /> */}

        <input ref={(ref) => { this.uploadInputAll = ref}} type='file' multiple={true} key={this.state.theInputFileKey + '_data_all'} style={{ display: 'none' }} onChange={(e) => this.onChangeDataFile(e)} accept="image/*,video/mp4,video/quicktime,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.svg,.pdf,.numbers,.key,.pages,.zip,.rar,.m4a,.mp3,.css,.eps,.raw,.cr2,.nef,.orf,.sr2,.TIF,.TIFF,.PSD,.XCF,.AI,.CDR,.CSS,.DXF,.EPS,.FLV,.HTML,.ICO,.RTF,.MTS,.ODS,.ODT,.OGG,.PHP,.PS,.PSD,.PUB,.SVG,.TSV,.TTF,.WAV,.WMV,.XPS,.JSON,.csv,.xml,.exe,.dmg,.mmap,.emmx,.mov,.AVI,.M4V" />      
      
        {this.state.flagBoxPopup && <div>
          <RxPopupUpload 
            fileListArr={this.state.fileListArr || []} 
            editFileSelected={(index, files) => this.editFileSelected(index, files)}
            deleteFileSelected={(index) => this.deleteFileSelected(index)}
            onChangeDataFile={(e) => this.onChangeDataFilePopup(e)}
            dropCanceBtnClick={() => this.dropCanceBtnClick()}
            acceptFile={this.state.acceptFile}
          />
        </div>}
      </div>
    )
  }
}
RxUploadFile.defaultProps = { callback: () => { } }
export default RxUploadFile